<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="用户统一平台" :bannerList="bannerList"></swiper>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <!-- 项目介绍 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="项目介绍"></main-title>
        <retract-list :dataList="introduceList"></retract-list>
      </div>
    </section>

    <!-- 产品特点 -->
    <section class="d-flex align-items-center pt-4  text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="产品特点"></main-title>
        <div class="indentation pb-4">
          <desc-list :dataList="lightSpotList"></desc-list>
        </div>
        <card-list :dataList="highList"></card-list>
      </div>
    </section>

  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'PlatForm',
  components: { Swiper,},
  props: {},
  data() {
    return {
      bannerList: [
        { src: require("@/assets/img/common/caseList/platForm/banner1.png") },
        { src: require("@/assets/img/common/caseList/platForm/banner2.png") },
      ],
      // 项目背景
      projectList: [
        '在应用系统的建设过程中，用户的管理是非常关键的一部分。随着需求的不断发展，应用系统也会不断增加或淘汰。在实际的工作中，应用系统通常都是在不同平台上由不同开发商开发，加上使用的技术不一致，容易造成每套系统都有独立的用户管理模块，登录不同应用系统需要多次登录。',
        '对于用户来说，每增加一个新的应用，需要记忆一套新的账号/密码，负责的业务范围越大，需要记忆的账号/密码组合越多。设定一样的密码，不够安全；密码设定不一样， 记忆困难。每次访问应用系统，需要重复输入账号/密码，在一个系统中修改了密码，其他系统的密码不会随之改变。',
        '对于系统管理员而言，没有一个统一的用户管理平台，就会在新进人员时，需要到众多系统中逐一建立帐号；人员离职时，需要到众多系统中逐一删除帐号，给系统管理员的工作造成了繁重负担，还容易造成各系统中人员信息的不一致。',
      ],
      // 项目介绍
      introduceList: [
        '统一管理平台旨在实现对多系统用户的集中管理，并为用户分配各应用系统的使用权限。',
        '1. 统一用户：统一管理平台实现了用户的集中管理和授权，管理员不再分散管理用户。',
        '2. 统一登录：用户可以通过一个账号/密码登录统一管理平台中的任何一个系统。'
      ],
      // 产品特点
      lightSpotList: [
        {
          title: "账号复用：",
          titleDetail:"统一管理平台中各系统中原有的用户账号依然可以独立存在并用于各系统登录。",
        },
        {
          title: "一键切换：",
          titleDetail: "用户在登录了统一管理平台中的任何一个系统后，无需再次登录账号，可直接切换到其他被授权的系统。",
        }
      ],
      highList: [
        {
          src: require("@/assets/img/common/platForm/highlights1.png"),
          smSrc: require("@/assets/img/common/platForm/highlights1-s.png"),
          title: '安全灵活'
        },
        {
          src: require("@/assets/img/common/platForm/highlights2.png"),
          smSrc: require("@/assets/img/common/platForm/highlights2-s.png"),
          title: '高效快捷'
        },
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style scoped>
</style>